@if (!inEditMode() || !canEdit()) {
    <span class="st-section-label__label">{{ section().Label }}</span>
}
@if (inEditMode() && canEdit()) {
    <mat-form-field
        required
        appearance="outline"
        class="st-section-label-form-field">
        <mat-label>{{ section().Label }}</mat-label>
        <input
            #sectionLabel
            matInput
            required
            [placeholder]="languageSettings.PSTWebSectionNameLabel"
            [(ngModel)]="currentValue" />
        <mat-hint>
            <mat-icon (click)="onSave($event)">done</mat-icon>
            <mat-icon (click)="onCancel($event)">close</mat-icon>
        </mat-hint>
    </mat-form-field>
}
